<template>
  <div v-if="screenData" class="view tv dark">
    <Screen :data="tv1Screen2">
      <template #aside>
        <AsideBlock>
          <h4>{{ $t('sections.synthesis') }}</h4>
          <TransportList :current-filter="screenData.currentTransportFilter" :distribution="tv1Distribution" :index="index" />
        </AsideBlock>
      </template>
      <TableBlock :data="tv1Screen2.data" :index="index" />
    </Screen>
    <Screen v-if="state === ''" :data="tv2Screen2">
      <TableBlock :data="tv2Screen2.data" :index="index" />
    </Screen>
    <Screen v-if="state === ''" :data="tv3Screen2">
      <TableBlock :data="tv3Screen2.data" :index="index" />
      <SensitiveCase />
    </Screen>
  </div>
</template>

<script>
import Tv from './TvMixin';
export default {
  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    tv1Distribution() {
      if (this.index >= 0) {
        const { filteredCollaborators, sites } = this.screenData;
        return this.computeTransportDistribution(sites[this.index], filteredCollaborators);
      }
      return {
        car: 0,
        public: 0,
      };
    },

    tv1Screen2() {
      const { averageTime, sites } = this.screenData;
      return {
        heading: {
          caption: this.$t('averageAccessTime'),
          icon: 'clock',
          baseline: {
            value: averageTime,
            sub: ' min',
            caption: `${this.$t('CurrentSiteName')} :`,
          },
        },
        data: {
          entries: this.computeAverageTime(sites, averageTime),
        },
      };
    },

    tv2Screen2() {
      const { filteredCollaboratorsCount, sites } = this.screenData;
      const value = filteredCollaboratorsCount;
      return {
        heading: {
          caption: this.$t('sections.impact'),
          icon: 'happy',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data: {
          entries: sites.map(site => {
            const { impact } = site.details;
            return [
              {
                type: 'sub-header',
                caption: `${this.$t('improvements')} :`,
              },
              {
                entries: [
                  {
                    value: impact.improvement.count,
                    icon: 'face',
                  },
                  {
                    value: filteredCollaboratorsCount ? Math.round((impact.improvement.count / filteredCollaboratorsCount) * 100) : 0,
                    sub: '%',
                  },
                ],
              },
              {
                type: 'sub-header',
                caption: `${this.$t('degradations')} :`,
              },
              {
                entries: [
                  {
                    value: impact.decay.count,
                    icon: 'face',
                  },
                  {
                    value: filteredCollaboratorsCount ? Math.round((impact.decay.count / filteredCollaboratorsCount) * 100) : 0,
                    sub: '%',
                  },
                ],
              },
            ];
          }),
        },
      };
    },

    tv3Screen2() {
      const entries = this.comuputesensibleCaseDecay();
      return {
        heading: {
          caption: this.$t('sections.outlier'),
          icon: 'alert',
        },
        data: {
          entries,
        },
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });

    setTimeout(() => {
      this.$store.dispatch('updateGlobalFilters', {
        key: 'currentMatchingTime',
        value: 'custom',
      });
      this.screenData = this.$store.getters.screen('tv2');
    }, 2000);
  },
};
</script>
